export default __webpack_public_path__ + "static/media/pyro-strike.80ca3675.svg";